module.exports = __webpack_public_path__ + "static/media/truecaller_icon.51a04008.svg";